import React from 'react'
export default function Articles() {
  return (
    <div>
      <div className='InterFont'>Articles coming soon</div>
    </div>
    
  )
}
